<template>
    <div class="full-height flex">
        <nested-file-sidebar v-on:change-category="changeCategory"/>
        <div id="content-wrapper">
            <header id="header" class="no-bg">
                <div class="container">
                    <div>
                        <ul class="breadcrumbs">
                            <li>
                                <router-link :to="{ name: 'view-group', params: { group: group.slug }}">
                                    {{ group.name }}
                                </router-link>
                            </li>
                            <li v-for="crumb in breadcrumbs" :key="crumb.id">
                                <router-link :to="{ name: 'view-category', params: { group: group.slug, category: crumb.slug }}">
                                    {{ crumb.name }}
                                </router-link>
                            </li>
                        </ul>
                        <h1>{{ post.title }}</h1>
                    </div>

                    <div class="actions">
                        <share-button :post="post" v-if="post.can.edit"></share-button>
                        <a class="btn btn-create btn-small" :href="post.meta.url + '?as=' + post.title">
                            <i class="icon ion-md-download"></i>
                        </a>
                    </div>
                </div>
                <nav class="container">
                </nav>
            </header>
            <div class="container">
                <iframe v-if="post.meta.type === 'application/pdf'" :src="post.meta.url + '?view=true&' + 'as=' + post.title" width="100%" style="width: 100%; height: 500px;border: none;"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import MicroModal from 'micromodal';
    import ListFiles from '../../../list/ListFiles';
    import {DraggableTree} from 'vue-draggable-nested-tree';

    export default {
        components: {
            DraggableTree
        },
        watch: {
            category: {
                deep: true,
                handler() {
                    this.changeCategory( this.category );
                }
            }
        },
        computed: {
            selectedCount(){
                return Object.keys(this.selectedPosts).length
            },
            fileOrFiles(){
                if( this.selectedCount === 1 ){
                    return 'file';
                }

                return 'files';
            },
            ...mapState({
                group: state => state.group.group,
            })
        },
        props: ['category', 'post'],
        data() {
            return {
                breadcrumbs: null,
                apiURL: '/api/groups/' + this.$route.params.group + "/posts",
                filters: {
                    category: this.category,
                },
                new_category: null,
                selectedPosts: {},
                moveFolder: null
            }  
        },
        created() {
            // this.group = JSON.parse(JSON.stringify(this.group));
            if(this.$route.params.category){
                this.changeCategory(this.$route.params.category);
            }
        },
        methods: {
            openModal(modal) {
                MicroModal.show(modal);
            },
            newFile() {
                this.$refs.filesTable.$refs.vuetable.refresh();
            },
            changeCategory(category) {
                this.filters.category = category;
            },
            updateBreadcrumbs(breadcrumbs) {
                this.breadcrumbs = breadcrumbs;
            },
            updateCategories(category) {
                this.group.categories.forEach((cat, index) => {
                    if(cat.id === category.id) {
                        this.$set(this.group.categories, index, category);
                    }
                });
            },
            insertCategory(category) {
                category.children = [];
                this.$set(this.group.categories, this.group.categories.length, category);
                //this.group.categories.push(category);
            },
            selectedPost(post) {
                this.$set(this.selectedPosts, post.id, post);
            },
            deselectedPost(post) {
                this.$delete(this.selectedPosts, post.id);
            },
            moveFiles(){
                if(this.moveFolder){
                    var url = '/api/groups/' + this.$route.params.group + '/categories/' + this.moveFolder + "/bulk-move";

                    axios.patch(url, {posts: Object.keys(this.selectedPosts)}).then((response) => {
                        MicroModal.close("move-files");
                        this.selectedPosts = [];
                        this.moveFolder = null;
                        this.$refs.filesTable.$refs.vuetable.refresh();
                    }, (response) => {
                        this.error = response;
                    });
                }
            },
            deleteFiles(){
                if(this.selectedPosts){
                    var url = '/api/groups/' + this.$route.params.group + "/bulk-delete";

                    axios.patch(url, { posts: Object.keys(this.selectedPosts) } ).then((response) => {
                        this.selectedPosts = [];
                        this.$refs.filesTable.$refs.vuetable.refresh();
                        MicroModal.close("delete-files");
                    }, (response) => {
                        this.error = response;
                    });
                }
            }
        }
    }
</script>